
import React from "react";
import PropTypes from "prop-types";
import FeatureUpgrade from "./feature";
import UsageUpgrade from "./usage";
import RBACRestriction from "./rbac";

function UpgradePopup({ type = "feature", ...props }) {
    if (type === "usage") {
        return <UsageUpgrade {...props} />;
    }

    if (type === "rbac") {
        return <RBACRestriction {...props} />;
    }

    return <FeatureUpgrade {...props} />;
}

UpgradePopup.propTypes = {
    type: PropTypes.oneOf(["feature", "usage", "rbac"]),
    // Props passed down to children:
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    featureName: PropTypes.string,
    planRequired: PropTypes.string,
    message: PropTypes.string, // [NEW]
};

export default UpgradePopup;